var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingsWheelGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67857 1V3.42857L6.46429 4.03571L4.64286 2.21429L2.21429 4.64286L4.03571 6.46429L3.42857 7.67857H1V11.3214H3.42857L4.03571 12.5357L2.21429 14.3571L4.64286 16.7857L6.46429 14.9643L7.67857 15.5714V18H11.3214V15.5714L12.5357 14.9643L14.3571 16.7857L16.7857 14.3571L14.9643 12.5357L15.5714 11.3214H18V7.67857H15.5714L14.9643 6.46429L16.7857 4.64286L14.3571 2.21429L12.5357 4.03571L11.3214 3.42857V1H7.67857Z",
    stroke: "#455A64",
    strokeWidth: 1.54545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49986 11.9279C10.8411 11.9279 11.9284 10.8406 11.9284 9.49937C11.9284 8.15811 10.8411 7.0708 9.49986 7.0708C8.1586 7.0708 7.07129 8.15811 7.07129 9.49937C7.07129 10.8406 8.1586 11.9279 9.49986 11.9279Z",
    stroke: "#455A64",
    strokeWidth: 1.54545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsWheelGray);
export default __webpack_public_path__ + "static/media/settings_wheel_gray.fd87d35d28b015926d9fd05142ae1003.svg";
export { ForwardRef as ReactComponent };